import { Right, Left } from "@insightfulscience/shared-utils/either";
import { expectGqlError } from "../AppError/expectGqlError";
import routes from "../routes";
import { gotoPath } from "../nav-utils";

/**
 * Tries to forgotPassword and redirects to /account if succeeded
 *
 * @type {
		(form: { email: string; }) =>
			(container: { authService: any; }) =>
				Promise<import("../utils-shared/either").Either<string, void>>
	} */
export const forgotPasswordFormAction = ({ email }) => ({ authService }) =>
	authService
		.forgotPassword(email)
		.then(gotoPath(routes.auth.forgotPasswordSuccess))
		.then(Right, Left.from(expectGqlError(404)));
